import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { getColumnWidth } from '../functions/grid-utils';

/**
 * Returns a column width that is guaranteed to be at least wide enough to
 * fit the given header text without truncation. Kendo's autoFitColumns()
 * does not reliably account for headers rendered via kendoGridHeaderTemplate,
 * so the required minimum width is measured manually and used as a floor.
 */
@Pipe({ name: 'automaticColumnWidth' })
@Injectable({ providedIn: 'root' })
export class AutomaticColumnWidthPipe implements PipeTransform {
    transform(
        title: string = '',
        baseWidth: number = 60,
        padding?: number,
    ): number {
        return getColumnWidth(title, baseWidth, padding);
    }
}
